import React from "react";

// One number tile on a dashboard (overview, payments, bulk purchase)
export default function Stat({ label, value, meta, icon, warn }) {
  return (
    <div className={`stat-card ${warn ? "stat-warn" : ""}`}>
      <div className="stat-top">
        <span>{label}</span>
        <span className="stat-icon">{icon}</span>
      </div>
      <strong>{value}</strong>
      <small>{meta}</small>
    </div>
  );
}
